import type { Identifier } from "ra-core";
import { useTimeout, useTranslate } from "ra-core";
import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";

import { NoteMobile } from "./NotesIteratorMobile";
import { BCInteractionEntryMobile } from "./BCInteractionEntryMobile";
import { useContactTimeline } from "./useContactTimeline";

export const ContactTimelineMobile = ({
  contactId,
  showStatus,
  onAddNote,
}: {
  contactId: Identifier;
  showStatus?: boolean;
  onAddNote?: () => void;
}) => {
  const translate = useTranslate();
  const { data, isPending } = useContactTimeline(contactId);
  const oneSecondHasPassed = useTimeout(1000);

  if (isPending) {
    if (!oneSecondHasPassed) return null;
    return (
      <div>
        {Array.from({ length: 3 }).map((_, i) => (
          <div className="space-y-2 mt-1" key={i}>
            <div className="flex flex-row space-x-2 items-center">
              <Skeleton className="w-full h-4" />
            </div>
            <Skeleton className="w-full h-12" />
            <Separator />
          </div>
        ))}
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <p className="text-muted-foreground mb-4">
          {translate("resources.notes.empty")}
        </p>
        {onAddNote && (
          <Button variant="outline" onClick={onAddNote}>
            {translate("resources.notes.action.add")}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="divide-y">
      {data.map((item) =>
        item.type === "note" ? (
          <NoteMobile
            key={`note-${item.data.id}`}
            note={item.data}
            contactId={contactId}
            showStatus={showStatus}
          />
        ) : (
          <BCInteractionEntryMobile
            key={`bc-${item.data.id}`}
            interaction={item.data}
          />
        ),
      )}
    </div>
  );
};
